module.exports = __webpack_public_path__ + "static/media/Chresta.b4253437.jpg";